import { Box } from '@chakra-ui/layout';
import { BeatLayout } from '@evt/beat';
import { BeatHorizontalCardExample } from '../components/Card/HorizontalCard';
import {
  CardsWrapper,
  CardRow,
} from './styles';


import { ArrowBackIcon, SettingsIcon } from '@chakra-ui/icons';
import {
  FiHome, FiBox, FiBriefcase, FiClipboard, FiDollarSign,
} from 'react-icons/fi';


const sidebarOptions = [
  {
    icon: <FiHome />,
    title: 'Home',
    mb: 0,
    onClick: () => console.log('Home'),
  },
  {
    icon: <FiBox />,
    title: 'Products',
    mb: 0,
    onClick: () => console.log('Products'),
  },
  {
    icon: <FiClipboard />,
    title: 'Orders',
    mb: 0,
    onClick: () => console.log('Orders'),
  },
  {
    icon: <FiBriefcase />,
    title: 'Contracts',
    mb: 0,
    onClick: () => console.log('Contracts'),
    currentActive: true,
  },
  {
    icon: <FiDollarSign />,
    title: 'Price colletction',
    mb: 0,
    onClick: () => console.log('Price colletction'),
  },
];

const sidebarActionOptions = [
  {
    icon: <SettingsIcon />,
    title: 'Settings',
    mb: 0,
    onClick: () => console.log('Settings'),
  },
  {
    icon: <ArrowBackIcon />,
    title: 'Quit',
    mb: 0,
    onClick: () => console.log('Quit'),
  },
];

export const Home = () => (
  <Box>
    <BeatLayout logoURL="https://upload.wikimedia.org/wikipedia/commons/a/ab/Logo_TV_2015.png"
      options={sidebarOptions}
      actionOptions={sidebarActionOptions}>
      <CardsWrapper>
        <CardRow>
          <BeatHorizontalCardExample />
        </CardRow>
      </CardsWrapper>
    </BeatLayout>
  </Box>
);
